import React from 'react';

const chipStyle = (hex) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 72,
  padding: '3px 8px',
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 700,
  backgroundColor: `${hex}22`,
  color: hex,
  border: `1px solid ${hex}55`,
  whiteSpace: 'nowrap',
});

const ProductionStatusChip = ({ status, color = '#64748b' }) => (
  <span style={chipStyle(color)}>{status || '—'}</span>
);

export default ProductionStatusChip;
